/**
 * It's a generated file, preferable to extend this in external file
 */
import {enumType} from 'common/enumType';
import * as yup from 'common/yup';

export type AdminResourceTypeUnion = keyof typeof AdminResourceType.enum;

export const AdminResourceType = enumType({
   SETTINGS: 'Manage Settings',
   SECURITY: 'Manage Security',
   REPORTS: 'Run Reports',
   JOB_MONITOR: 'Job Monitor',
   DASHBOARD: 'Dashboard Admin',
   SFTP_SERVER: 'File Transfer Server Admin',
   PASSWORDS: 'View Passwords',
   LOGS: 'View Logs',
   JSON_API: 'JSON API',
   BACKUP_RESTORE: 'Backup/Restore',
} as const);

export const AdminResourceTypeSchema = yup.string().oneOf(AdminResourceType.keys);
export type IAdminResourceType = yup.InferType<typeof AdminResourceTypeSchema>;
